import pino from "pino";

const logLevel = process.env.REACT_APP_LOG_LEVEL || (process.env.NODE_ENV === 'production' ? 'warn' : 'info'); // there's no 'debug' in the Chrome console

const logger = pino({
  browser: {
    asObject: true, // Makes logs easier to read in the browser console
  },
  level: logLevel,
});

export default logger;
